(function() {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;
                    if (!f && c) return c(i, !0);
                    if (u) return u(i, !0);
                    var a = new Error("Cannot find module '" + i + "'");
                    throw a.code = "MODULE_NOT_FOUND", a;
                }
                var p = n[i] = {
                    exports: {}
                };
                e[i][0].call(p.exports, function(r) {
                    var n = e[i][1][r];
                    return o(n || r);
                }, p, p.exports, r, e, n, t);
            }
            return n[i].exports;
        }
        for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) o(t[i]);
        return o;
    }
    return r;
})()({
    1: [ function(require, module, exports) {
        "use strict";
        class LoginForm {
            constructor() {
                this.$form = $('form[id$="_login"]');
                this.$submitButton = this.$form.find('input[type="submit"]');
                this.$errorContainer = $(".js-error-message");
                this.errorMessageHtml = `<em class="entry-formgroup_error"></em>`;
                this.lineConnectMemberIdErrorMessageHtml = `<div class="entry-error-message d-block"><p></p></div>`;
                this.$form.off("submit").on("submit", e => this.handleSubmitEvent(e));
            }
            startSubmit() {
                this.$submitButton.prop("disabled", true);
            }
            endSubmit() {
                this.$submitButton.prop("disabled", false);
            }
            showErrorMessages(errorMessageHtmls) {
                this.$errorContainer.empty();
                errorMessageHtmls.forEach(errorMessageHtml => {
                    const $errorMessage = $(this.errorMessageHtml).html(errorMessageHtml);
                    this.$errorContainer.append($errorMessage);
                });
                this.scrollToErrorMessage();
            }
            showBrandMemberIdErrorMessage(errorMessageHtmls) {
                this.$errorContainer.empty();
                errorMessageHtmls.forEach(errorMessageHtml => {
                    const $errorMessage = $(this.lineConnectMemberIdErrorMessageHtml).html(errorMessageHtml);
                    this.$errorContainer.append($errorMessage);
                });
                this.scrollToErrorMessage();
            }
            scrollToErrorMessage() {
                const scrollTop = $(window).scrollTop() < $("header").outerHeight() ? this.$errorContainer.offset().top - $("header").outerHeight() * 4 : this.$errorContainer.offset().top - $("header").outerHeight() * 2;
                $("html,body").animate({
                    scrollTop: scrollTop
                }, "fast");
            }
            handleSubmitEvent(e) {
                e.preventDefault();
                this.startSubmit();
                $.ajax({
                    url: this.$form.attr("action"),
                    type: "POST",
                    data: this.$form.serialize(),
                    dataType: "json"
                }).done(response => this.handleSubmitSuccess(response)).fail(jqXHR => this.handleSubmitError(jqXHR));
                return false;
            }
            handleSubmitSuccess(data) {
                if (data.redirectUrl != null) {
                    location.href = data.redirectUrl;
                    return;
                }
                location.href = window.Urls.generalError;
            }
            handleSubmitError(jqXHR) {
                try {
                    const response = JSON.parse(jqXHR.responseText);
                    if (response.isSystemError) {
                        location.href = window.Urls.generalError;
                    } else if (response.isAdditionalAuthRequired) {
                        if (response.errorMessageHtmls) {
                            this.showErrorMessages(response.errorMessageHtmls);
                        } else {
                            this.showAdditionalAuthModal(response);
                        }
                    } else if (response.isBrandMemberIdCheckFailed) {
                        this.showBrandMemberIdErrorMessage(response.errorMessageHtmls);
                    } else if (response.errorMessageHtmls) {
                        this.showErrorMessages(response.errorMessageHtmls);
                    } else if (response.redirectUrl) {
                        location.href = response.redirectUrl;
                    } else {
                        location.href = window.Urls.generalError;
                    }
                } catch (error) {
                    location.href = window.Urls.generalError;
                } finally {
                    this.endSubmit();
                }
            }
            showAdditionalAuthModal(responseJSON) {
                $("body").append(responseJSON.modalContentHtml);
                const OmotionAuth = require("./OmotionAuth");
                new OmotionAuth;
            }
        }
        module.exports = LoginForm;
    }, {
        "./OmotionAuth": 2
    } ],
    2: [ function(require, module, exports) {
        "use strict";
        class OmotionAuth {
            constructor() {
                this.$modalOverlay = $(".omotion-modal-overlay");
                this.$form = this.$modalOverlay.find("form");
                this.$authCodeInput = this.$form.find('input[name="authCode"]');
                this.$submitButton = this.$form.find('input[type="submit"]');
                this.$errorContainer = this.$form.find(".js-omotion-error-container");
                this.errorMessageHtml = `<em class="js-omotion-error-message omotion-error-message"></em>`;
                $("#wrapper, footer").attr("inert", true);
                this.bindEvents();
            }
            bindEvents() {
                this.$modalOverlay.find(".omotion-modal-close").on("click", e => {
                    this.handleCloseEvent(e);
                });
                this.$form.on("submit", e => this.handleSubmitEvent(e));
            }
            handleCloseEvent(e) {
                this.$modalOverlay.remove();
                $("#wrapper, footer").removeAttr("inert");
            }
            handleSubmitEvent(e) {
                e.preventDefault();
                this.$submitButton.prop("disabled", true);
                if (!this.validateForm()) {
                    this.$submitButton.prop("disabled", false);
                    return false;
                }
                $.ajax({
                    url: this.$form.attr("action"),
                    method: this.$form.attr("method"),
                    data: this.$form.serialize(),
                    dataType: "json"
                }).done(response => this.handleSubmitSuccess(response)).fail(jqXHR => this.handleSubmitError(jqXHR));
            }
            handleSubmitSuccess(response) {
                location.href = response.redirectUrl;
            }
            handleSubmitError(jqXHR) {
                try {
                    const response = JSON.parse(jqXHR.responseText);
                    if (response.redirectUrl) {
                        location.href = response.redirectUrl;
                    } else if (response.errorMessageHtml) {
                        const errorMessageElement = $(this.errorMessageHtml).html(response.errorMessageHtml);
                        this.$errorContainer.empty().append(errorMessageElement);
                    } else {
                        location.href = window.Urls.generalError;
                    }
                } catch (error) {
                    location.href = window.Urls.generalError;
                } finally {
                    this.$submitButton.prop("disabled", false);
                }
            }
            validateForm() {
                this.$authCodeInput.removeClass("omotion-input-error");
                this.$form.find(".js-omotion-error-message").remove();
                if (this.$authCodeInput.val().trim() === "") {
                    this.$authCodeInput.addClass("omotion-input-error").after($(this.errorMessageHtml).text(window.Resources.VALIDATE_REQUIRED));
                    return false;
                }
                return true;
            }
        }
        module.exports = OmotionAuth;
    }, {} ],
    3: [ function(require, module, exports) {
        (function($, shdGBSJ) {
            var helper = shdGBSJ.validate.helper;
            var modal = shdGBSJ.modal;
            var passwordResetFormWrapper = $("#modal").length ? "#modal .entry_modal_body-inner" : ".entry_modal_body-inner";
            $(function() {
                $("#dwfrm_login").validate({
                    errorClass: "entry-formgroup_error",
                    rules: {
                        dwfrm_login_username: {
                            shdRequired: true,
                            email: false
                        },
                        dwfrm_login_password: {
                            shdRequired: true
                        }
                    }
                });
                function populateRequestPasswordForm($requestPasswordForm) {
                    $requestPasswordForm.validate({
                        errorClass: "entry-formgroup_error",
                        groups: {
                            birthday: "dwfrm_requestpassword_year dwfrm_requestpassword_month dwfrm_requestpassword_day"
                        },
                        rules: {
                            dwfrm_requestpassword_email: {
                                shdRequired: true,
                                email: false
                            },
                            dwfrm_requestpassword_year: {
                                shdRequired: true
                            },
                            dwfrm_requestpassword_month: {
                                shdRequired: true
                            },
                            dwfrm_requestpassword_day: {
                                shdRequired: true
                            },
                            dwfrm_requestpassword_postalCode: {
                                shdRequired: true
                            }
                        },
                        errorPlacement: function(error, element) {
                            var name = element.attr("name");
                            if (name === "dwfrm_requestpassword_year" || name === "dwfrm_requestpassword_month" || name === "dwfrm_requestpassword_day") {
                                $(error).addClass($(error).attr("class") + "--birthday");
                                element.parent().parent().parent().append(error);
                            } else {
                                element.after(error);
                            }
                        }
                    });
                }
                $("#password-reset").off("click").on("click", function(e) {
                    e.preventDefault();
                    $("#modal").find(".entry-modal_body").empty();
                    $.ajax({
                        url: $(e.target).attr("href"),
                        data: "&format=ajax",
                        success: function(response) {
                            $("#modal").find(".entry-modal_body").html(response);
                            modal.resizeModal();
                        }.bind(this)
                    });
                });
                $(document).on("click", passwordResetFormWrapper + ' form[name$="_requestpassword"] [name$="_requestpassword_send"]', function(e) {
                    var $requestPasswordForm = $('[name$="_requestpassword"]');
                    populateRequestPasswordForm($requestPasswordForm);
                    var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
                    if (!$requestPasswordForm.valid()) {
                        return;
                    }
                    $(this).prop("disabled", true);
                    e.preventDefault();
                    var data = $requestPasswordForm.serialize();
                    data += "&" + $submit.attr("name") + "=";
                    if (data.indexOf("ajax") === -1) {
                        data += "&format=ajax";
                    }
                    const that = this;
                    $.ajax({
                        type: "POST",
                        url: $requestPasswordForm.attr("action"),
                        data: data
                    }).done(function(response) {
                        if (typeof response === "string") {
                            if ($("#modal_complete").length) {
                                $("#modal_complete").find(".entry-modal_body").empty().html(response);
                                modal.toggle("modal");
                                modal.toggle("modal_complete");
                            } else {
                                $(passwordResetFormWrapper).empty().html(response);
                                $(".entry-formgroup_submit.entry-formgroup_submit--modal.entry-formgroup_submit--link").remove();
                            }
                            return;
                        }
                        if (response.isSystemError) {
                            window.location.href = Urls.generalError;
                            return;
                        }
                        if (response.error === "CSRF Token Mismatch") {
                            window.location.href = Urls.csrffailed;
                            return;
                        }
                        $(passwordResetFormWrapper).find(".entry-formgroup_error.summary").text(response.errorMessage);
                        $(passwordResetFormWrapper).find(".entry-formgroup_error.summary").show();
                    }).fail(function() {
                        $(passwordResetFormWrapper).html('<h1 class="entry-modal_title">' + Resources.SERVER_ERROR + "</h1>");
                        modal.resizeModal();
                    }).always(function() {
                        $(that).prop("disabled", false);
                    });
                });
                const $form = $("form[id^=dwfrm_login]");
                if ($form.length > 0) {
                    const LoginForm = require("./components/LoginForm");
                    new LoginForm;
                }
            });
        })(window.jQuery, window.shdGBSJ);
    }, {
        "./components/LoginForm": 1
    } ]
}, {}, [ 3 ]);